import React, { Component, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { fetchCares } from '../actions';
import Helmet from '../components/Helmet';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import config from '../../helpers/config';

import { PageCover, Logo, Separator, LogoBanner, Container } from  '../components';
import hash from '../../helpers/hash';
import { useParams, NavLink } from 'react-router-dom';
import MainContent from '../components/cares/MainContent';
import useDeepCompareEffect from 'use-deep-compare-effect'

const useStyles = makeStyles(theme => ({
    caresBackground: {
        backgroundColor: '#fcfeff'
    },
    logoDiv: {
        padding: '100px 0px'
    },
    bannerText: props => ({
        lineHeight: '200px',
        textAlign: 'center',
        letterSpacing: '30px',
        textShadow: '1px 1px 2px #ffffff',
        color: "white",

        '&.medical': {
            backgroundColor: hash.walk("theme.primary", props) || "white",
        },
        '&.service': {
            backgroundColor: hash.walk("theme.gray", props) || "white",
        },
        '&.certificate': {
            display: 'block',
            backgroundColor: hash.walk("theme.secondary", props) || "white",
            [theme.breakpoints.down("xs")]: {
                display: 'none'
            },
        },
        '&.certificate.mobile': {
            display: 'none',
            backgroundColor: hash.walk("theme.secondary", props) || "white",
            [theme.breakpoints.down("xs")]: {
                display: 'block'
            },
        },

        '&.certifications': {
            backgroundColor: hash.walk("theme.secondaryLight", props) || "white",
        },

        [theme.breakpoints.down("xs")]: {
            lineHeight: '100px',
            textShadow: 'none',
            letterSpacing: '15px',
        }
    }),

    container1: props => ({
        height: 500,

        [theme.breakpoints.down("xs")]: {
            height: 350,
        },
        '& .profile': {
            height: 450,      
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            [theme.breakpoints.down("xs")]: {
                height: 300,
                width: '70%',
                margin: '0 15%'
            },
        },
        '& .profession': {
            position: 'relative',
            paddingTop: 15,
            height: 35,
            textAlign: 'center',
            '& span': {
                borderBottom: "3px solid #dadada"
            },
            
            '& .bg': {
                position: 'absolute',
                bottom: 0,
                left: 0,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '85%',
                backgroundPosition: 'center',
                width: 72,
                height: 67,
                transform: "scale(2)",
                left: "30%",
                bottom: "-20%",
            }
        },
    }), 

    container2: props => ({
        height: 750,
        [theme.breakpoints.down("xs")]: {
            height: 450,
        },
        '& .profile': {
            height: 700,      
            width: '70%',
            margin: '0 15%',
            backgroundSize: 'cover',
            backgroundImage: `url(${config.S3Endpoint}${hash.walk('nursingTeam.imgUrl', props)})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            [theme.breakpoints.down("xs")]: {
                height: 400, 
                width: '90%',
                margin: '0 5%',
            },
        },
        '& .profession': {
            paddingTop: 15,
            height: 35,
            textAlign: 'center',
            '& span::before': {
                content: '""',
                width: '30%',
                borderBottom: '3px solud #2ab8c3'
            },
            '& span::after': {
                content: '""',
                width: '30%',
                borderBottom: '3px solud #b9548e'
            }
            
        }
    }),

    container3: props => ({
        '& .profile': {
            height: 350,      
            width: '70%',
            margin: '50px 15%',
            [theme.breakpoints.down("xs")]: {
                margin: '15px 15%',
            },
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        '& .profession': {
            paddingTop: 0,
            height: 0,
            textAlign: 'center',
            '& h4': {
                display: 'none'
            },
            '& span::before': {
                content: '""',
                width: '30%',
                borderBottom: '3px solud #2ab8c3'
            },
            '& span::after': {
                content: '""',
                width: '30%',
                borderBottom: '3px solud #b9548e'
            }
            
        }
    }),

    switchButton: props => ({
        display: 'inline-block',
        padding: '10px 50px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '25px',
        textDecoration: 'none',

        [theme.breakpoints.down("xs")]: {
           padding: '10px 25px', 
        }, 

        '&.mommy': {
            color: hash.walk('theme.primary', props),
            '&.selected': {
                color: "white",
                backgroundColor: hash.walk('theme.primary', props),
            }
        },
        '&.baby': {
            color: hash.walk('theme.secondary', props),
            '&.selected': {
                color: "white",
                backgroundColor: hash.walk('theme.secondary', props),
            }
        }
    }),  

    separator1: {
        height: 100,
        width: '100%',
        [theme.breakpoints.down("xs")]: {
            height: 25,
        }, 
    },

    separator2: {
        height: 150,
        width: '100%',
        [theme.breakpoints.down("xs")]: {
            height: 50,
        }, 
    },
}));

const CaresPage = (props) => {

    const theme = useTheme();
    const [id, setId] = useState(useParams().id);
    const contentRef = useRef(null);
    const starColor = 'rgb(185, 84, 142)';

    useEffect(() => {
        console.log(id)
        if (id === "mommy" || id === "baby") {
            props.cares.skipScroll = true;
            contentRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    }, [id]);


    const { cares } = props;
    const classes = useStyles(cares);
    
    useDeepCompareEffect(() => {
        if (!cares.isLoaded) props.fetchCares();
    }, [cares])

    if (!cares.isLoaded) {
        return <div>Loading...</div>;
    }
     
    const PageCoverProps = {
        ...cares,
        style: {
            height: 'calc(100vh - 75px)',
            title: {
                position: 'absolute',
                top: 'auto',
                right: '0',
                bottom: '10%',
                left: 'auto',
                width: '33%',
                letterSpacing: '10px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: 'white',
                fontWeight: '500',
                padding: '20px 0px 20px 5vw',
                borderTopLeftRadius: '40px',
                borderBottomLeftRadius: '40px',
                border: '1px solid #dadada',
                textShadow: '1px 1px 4px black',
                '& h1': {
                    float: 'left',
                    fontWeight: '500'
                },
                [theme.breakpoints.down('xs')] : {
                    width: '75%',
                }
            }
        }
    };
    const Profession = (props) => {
        const getSize = (num) => {
            if ((num / props.items.length) > 12) {
                return 12;
            }
            return num / props.items.length;
        }
        const lg = getSize(12),
            md = getSize(12),
            sm = getSize(24),
            xs = getSize(48);
        return (
            <div>
                <Grid container justify="center" alignItems="center" spacing={1}>
                    {props.items.map((d, i) => 
                        <Grid key={i} item xs={xs} sm={sm} md={md} lg={lg}>
                            <div className={`${props.classes.root} c${i}`}>
                                <div className="profile" 
                                    style={{
                                        backgroundImage: `url(${config.S3Endpoint}${d.imgUrl})`, 
                                        backgroundPosition: d.imgPosition,
                                        border: d.borderColor ? `3px solid ${d.borderColor}` : `none`,   
                                        borderRadius: '25px',
                                    }}
                                >
                                </div>
                                <div className="profession">
                                    <div className="bg" style={{backgroundImage: `url(${config.S3Endpoint}${d.nameBgImgUrl})`}} ></div>
                                    <Typography variant="h4"> 
                                        <span style={{ borderColor: d.borderColor || 'none' }}><b>{d.name}</b></span> 
                                        <sub>&nbsp;{d.position}</sub>
                                    </Typography>
                                </div>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </div>
        )
    }

    
    return (
        <div className={classes.container}>
            <Helmet {...cares} />
            <div className={classes.caresBackground}>
                <PageCover {...PageCoverProps} > 
                    <Typography variant="h1">{cares.name}</Typography>
                </PageCover>

                <div className={classes.logoDiv}>
                    <Logo />
                </div>

                <LogoBanner height={200} bannerBgImgUrl={hash.walk('medicalTeam.imgUrl', cares)} ratio={0.9646}>
                    <Typography className={classes.bannerText  + ' medical'} variant="h1">{hash.walk('medicalTeam.name', cares)}</Typography>
                </LogoBanner>

                <Separator classes={{root: classes.separator1}} />

                <Container xsPadding="25px 0px 0px">             
                    <Profession items={hash.walk('medicalTeam.staff', cares)} classes={{root: classes.container1}}/>
                </Container>
            
                <Separator classes={{root: classes.separator2}} />

                <Profession items={hash.walk('nursingTeam.staff', cares)} classes={{root: classes.container2}}/>
{/* 
                <Separator classes={{root: classes.separator2}} />

                <LogoBanner height={200} bannerBgImgUrl={hash.walk('serviceTeam.imgUrl', cares)} ratio={0.9646}>
                    <Typography className={classes.bannerText  + ' service'} variant="h1">{hash.walk('serviceTeam.name', cares)}</Typography>
                </LogoBanner>
                
                <Separator classes={{root: classes.separator1}} />

                <Profession items={hash.walk('serviceTeam.staff', cares)} classes={{root: classes.container2}}/> */}

                <Separator classes={{root: classes.separator1}} />

                <LogoBanner height={200} bannerBgImgUrl={hash.walk('certificate.imgUrl', cares)} ratio={0.9646}>
                    <Typography className={classes.bannerText  + ' certificate'} variant="h1">
                        {hash.walk('certificate.name', cares)}
                    </Typography>
                    <Typography className={classes.bannerText  + ' certificate mobile'} variant="h1">
                        {hash.walk('certificate.mobileName', cares)}
                    </Typography>
                </LogoBanner>
                
                <Container padding="50px 0px">
                    <Typography variant="h4">
                        <span style={{color: starColor}}>&#10022;&nbsp;&nbsp;</span>{hash.walk('certificate.desc.0', cares)}
                    </Typography>
                </Container>

                <LogoBanner height={`auto`}>
                    <div className={classes.bannerText  + ' certifications'}>
                        <Profession items={hash.walk('certificate.certifications', cares)} classes={{root: classes.container3}} />
                    </div>
                </LogoBanner>
                
                
                <Separator classes={{root: classes.separator1}} />

                <Container>
                    <div style={{ textAlign: "center" }}>
                        <NavLink to="/cares/mommy" className={classes.switchButton + ' mommy ' + (id !== 'baby' ? 'selected' : '')} onClick={() => setId("mommy")} activeClassName="selected">
                            <Typography variant="h3"><b>寵愛媽咪</b></Typography>
                        </NavLink>
                        <Separator vertical width="15%" />
                        <NavLink to="/cares/baby" className={classes.switchButton + ' baby'} onClick={() => setId("baby")} activeClassName="selected">
                            <Typography variant="h3"><b>呵護寶貝</b></Typography>
                        </NavLink>
                    </div>
                </Container>

                <div ref={contentRef}>
                    <MainContent {...cares[id || "mommy"]} />
                </div>

            </div>
        </div>
    )
}

function mapStateToProps({ cares }) {
    return { cares };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchCares()),
    component:  connect(mapStateToProps, { fetchCares }) (CaresPage)
}



// WEBPACK FOOTER //
// ./src/client/pages/CaresPage.js